"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grado": {
    "32b53c5b": [{
      "hkey": "21797d97",
      "slug": "grado",
      "name": "Grado",
      "primary": true,
      "skipSearch": false
    }],
    "boscat": [{
      "hkey": "21797d97",
      "slug": "grado",
      "name": "Grado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f1b00ea": [{
      "hkey": "8aa727f1",
      "slug": "grado-pineta",
      "name": "Grado-Pineta",
      "primary": true,
      "skipSearch": false
    }],
    "pineta": [{
      "hkey": "8aa727f1",
      "slug": "grado-pineta",
      "name": "Grado-Pineta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4456cc13": [{
      "hkey": "21797d97",
      "slug": "grado",
      "name": "Grado",
      "primary": true,
      "skipSearch": false
    }],
    "val-cavarera": [{
      "hkey": "21797d97",
      "slug": "grado",
      "name": "Grado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;